// Small pure formatting / display helpers shared across the UI.

export const initials = (n = '') =>
  n
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('');

export const empEmail = (n = '') =>
  n
    .toLowerCase()
    .replace(/[^a-z ]/g, '')
    .split(' ')
    .slice(0, 2)
    .join('.') + '@augmentgroup.ai';

export const tenure = (d) => {
  const y = (Date.now() - new Date(d)) / 31557600000;
  return y >= 1 ? `${y.toFixed(1)} yrs` : `${Math.round(y * 12)} mo`;
};

// Currency formatters — USD across the whole UI (name kept for minimal churn).
export const fmtPKR = (n) => '$' + (Number(n) || 0).toLocaleString();
export const fmtM = (n) => '$' + ((Number(n) || 0) / 1000000).toFixed(1) + 'M';

// Currency-aware formatter (Phase 2 multi-currency). Used where amounts may be in
// a currency other than the default, e.g. consolidated payroll reporting.
const CURRENCY_SYMBOLS = { USD: '$', PKR: 'Rs ', EUR: '€', GBP: '£', AED: 'AED ', SAR: 'SAR ', INR: '₹' };
export const fmtMoney = (n, currency) => {
  const cur = String(currency || '').toUpperCase();
  const sym = CURRENCY_SYMBOLS[cur] || (cur ? cur + ' ' : '$');
  return sym + (Number(n) || 0).toLocaleString();
};

export const greeting = () => {
  const h = new Date().getHours();
  return h < 12
    ? 'Good morning'
    : h < 17
      ? 'Good afternoon'
      : h < 21
        ? 'Good evening'
        : 'Good night';
};
